import { useEffect, useRef } from 'react';

const useRenderPhase = (
  initialCallback: () => void,
  subsequentCallback: () => void,
  dependencies: any[]
) => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      if (initialCallback) {
        return initialCallback();
      }
    } else {
      if (subsequentCallback) {
        return subsequentCallback();
      }
    }
  }, dependencies);
};

export default useRenderPhase;
